import {
  List,
  TextField,
  Datagrid,
  ReferenceField,
  EditButton,
  ReferenceInput,
  AutocompleteInput,
  useCreate,
  SaveButton,
  SimpleForm,
  Toolbar,
  useRefresh,
  useNotify,
} from 'react-admin'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import Box from '@mui/material/Box'

const AssignPlaylistToolbar = () => {
  const [create] = useCreate()
  const refresh = useRefresh()
  const notify = useNotify()

  const { id } = useParams()
  const { getValues } = useFormContext()

  const onSubmit = async e => {
    e.preventDefault()

    const { entityId } = getValues()
    const organizationId = parseInt(id)

    create(
      'b2b-organization-playlists',
      {
        data: {
          organizationId,
          playlistId: entityId,
          type: 'playlist',
        },
      },
      {
        onSuccess: () => {
          refresh()
          notify('Playlist assigned successfully')
        },
        onError: error => {
          notify(`${error.message}`, { type: 'error' })
        },
      },
    )
  }

  return (
    <Toolbar>
      <SaveButton type="button" onClick={onSubmit} />
    </Toolbar>
  )
}

const AssignPlaylistAside = () => {
  return (
    <Box sx={{ margin: '0.5rem', width: 400 }}>
      <SimpleForm toolbar={<AssignPlaylistToolbar />}>
        <ReferenceInput
          source="entityId"
          reference="playlists"
          filter={{ status: 'active', type: 'internal' }}
          label="Select Playlist">
          <AutocompleteInput
            optionText="name"
            filterToQuery={searchText => ({
              name: { $iLike: `%${searchText}%` },
            })}
          />
        </ReferenceInput>
      </SimpleForm>
    </Box>
  )
}

const PlayListTab = ({ organizationId }) => {
  return (
    <>
      {!organizationId && (
        <Typography variant="body1">
          Bạn phải lưu "Thông tin công ty" trước khi cập nhật danh sách
          playlist!
        </Typography>
      )}
      {organizationId && (
        <List
          sx={{ width: '100%' }}
          disableSyncWithLocation
          actions={null}
          resource="b2b-organization-playlists"
          basePath="/b2b-organization-playlists"
          aside={<AssignPlaylistAside />}
          filter={{
            organizationId: organizationId,
            isRequiredOrganizationId: true,
          }}>
          <Datagrid rowClick={false}>
            <TextField source="playlistId" label="PlayList ID" />
            <ReferenceField
              source="playlistId"
              reference="playlists"
              filter={{ type: 'internal' }}
              label="Playlist">
              <TextField source="name" />
            </ReferenceField>
            <EditButton basePath="/b2b-organization-playlists" />
          </Datagrid>
        </List>
      )}
    </>
  )
}

export default PlayListTab
